import { api } from "../../../lib/api";

/**
 * Adds an email to the newsletter list. Resolves for a new address and for one
 * already on the list alike; throws on anything else (bad email, rate limit,
 * network), which the form shows as one error line.
 */
export async function subscribeToNewsletter(input: {
  email: string;
  lang: string;
  /** Honeypot value, empty for people. */
  company?: string;
}): Promise<void> {
  const { error } = await api.newsletter.post({
    email: input.email,
    lang: input.lang,
    source: "footer",
    ...(input.company ? { company: input.company } : {}),
  });
  if (error) throw new Error("newsletter_signup_failed");
}
